import { useTranslation } from 'react-i18next';

import { PartyDTO } from 'support/types';

import { Party } from './Party';

enum PartyType {
  Billing = 'billing',
  Delivery = 'delivery',
}

type BillingPartyProps = {
  selectedPartyId?: string;
  onSelectParty: (partyId: string) => void;
  parties: Array<PartyDTO> | undefined;
  onAddParty: (party: PartyDTO, onSuccess?: () => void) => void;
  onEditParty: (party: PartyDTO, onSuccess?: () => void) => void;
  disabled: boolean;
  error: string | null;
  clearError: () => void;
  isLoading: boolean;
};

export function BillingParty({
  parties,
  selectedPartyId,
  onSelectParty,
  onAddParty,
  onEditParty,
  disabled,
  error,
  clearError,
  isLoading,
}: BillingPartyProps) {
  const { t } = useTranslation();
  const sortedParties = [...(parties || [])].sort((a, b) => {
    const aHasIdentifier = hasBillingIdentifier(a);
    const bHasIdentifier = hasBillingIdentifier(b);
    if (aHasIdentifier === bHasIdentifier) {
      return 0;
    }
    return aHasIdentifier ? -1 : 1;
  });
  return (
    <>
      <p className="text-base leading-6 font-bold text-gray-900">{t('orderForms:checkout.billingAddress')}</p>
      <Party
        selectedPartyId={selectedPartyId}
        parties={sortedParties}
        partyType={PartyType.Billing}
        onSelectParty={onSelectParty}
        onAddParty={onAddParty}
        onEditParty={onEditParty}
        disabled={disabled}
        error={error}
        clearError={clearError}
        isLoading={isLoading}
      />
    </>
  );
}

const hasBillingIdentifier = (party: PartyDTO) =>
  !!party.identifiers?.some(
    (identifier) => (identifier.domain === 'GS1' || identifier.domain === 'vatID') && !!identifier.identifier,
  );
